import { Anywhere, DryVan, CARRIER_ASSIGNED_MODULE_WEB } from "../../../utils/constants";
import { NewDropDownData } from "../../../utils/mock_Data";
import { Search } from "../../../models/home/Search.model";
import { Isearch } from "../../../schemas/Search/Search.schema";
import { compareTwoDateWithoutTimestamp, getDateTimeByTimezoneInISOStringFormat } from "../../../utils";
import { getFormatRoles } from "../../../utils/formatData";
import { EVENT, SCREEN } from "../../../utils/constants.analytics";
import { isMobile } from "../../../utils/common";


const searchDate = (destinationData: any, offSet: any) => {
  const plannedDepartureDateTime = (destinationData?.plannedDepartureDateTime);
  const appointmentTo = (destinationData?.appointmentTo);
  const startDate = (plannedDepartureDateTime || appointmentTo);
  if (startDate && compareTwoDateWithoutTimestamp(startDate, new Date())) {
    return {
      pickUpStartDate: startDate,
      pickUpEndDate: getDateTimeByTimezoneInISOStringFormat(startDate.split("T")[0], offSet)
    }
  }
  const currentDate = getDateTimeByTimezoneInISOStringFormat();
  return {
    pickUpStartDate: currentDate,
    pickUpEndDate: getDateTimeByTimezoneInISOStringFormat(currentDate.split("T")[0], offSet)
  }
}

const isValidTrailerType = (trailerType:any) => {
  const isDefaultType = NewDropDownData?.some(({value})=>trailerType?.toLowerCase() === value.toLowerCase());
  return isDefaultType ? trailerType : DryVan;
}

const constructSearchParams = (destinationData: any, offSet: any, transportMode: any) => {
  const { pickUpStartDate, pickUpEndDate } = searchDate(destinationData, offSet?.originDateDefaultOffset);
  const searchParams: Isearch = {
    origin: (destinationData?.city) || Anywhere,
    originState: (destinationData?.state) || "",
    originCountry: (destinationData?.country) || "",
    originPostalCode: (destinationData?.postalCode || ""),
    originRadius: 100,
    TrailerType: isValidTrailerType(transportMode),
    pickUpEndDate: pickUpEndDate,
    pickUpStartDate: pickUpStartDate,
    destination: Anywhere,
    destinationCity: Anywhere,
    destinationStates: [],
    destinationCountry:"",
    destinationRadius: 100,
    destinationPostalCode:"",
  }
  return searchParams
}
const getDestinationCity =(destinationData:any)=>{
  return (destinationData?.city) || Anywhere;
  }
const getDestinationState =(destinationData:any) => {
return (destinationData?.state) || "";
}
const getDestinationStateArray =(destinationData:any) => {
  return (destinationData?.state) || [];
  }
const getDestinationCountry =(destinationData:any)=>{
  return (destinationData?.country) || "";
}
const getDestinationPostalCode =(destinationData:any)=>{
  return (destinationData?.postalCode) || "";
  }
 
const constructSearchData = (destinationData: any, userDetail: any, offSet: any, transportMode: any) => {
  const { pickUpStartDate, pickUpEndDate } = searchDate(destinationData, offSet?.originDateDefaultOffset);
  const userRole = getFormatRoles();
  const model: Search = new Search();
  model.originCity = getDestinationCity(destinationData);
  model.originState = getDestinationState(destinationData);
  model.originCountry =  getDestinationCountry(destinationData);
  model.originPostalCode = getDestinationPostalCode(destinationData);
  model.originRadius = 100;
  model.pickUpStartDate = pickUpStartDate;
  model.pickUpEndDate = pickUpEndDate;
  model.trailerType = isValidTrailerType(transportMode);
  model.size = 25;
  model.page = 0;
  model.sortColumn = "pickUpStartDate";
  model.sortDirection = "asc";
  model.destinationCity = Anywhere;
  model.destinationStates = [];
  model.destinationCountry = "";
  model.destinationPostalCode = "";
  model.dropStartDate = "";
  model.dropEndDate = "";
  model.destinationRadius = 100;
  model.trailerType = isValidTrailerType(transportMode);
  model.skipUserSearchHistory = true;
  model.userId = (userDetail?.memberDetailsResponse?.member?.upn) || "";
  model.carrierId = (userDetail?.memberDetailsResponse?.member?.carrierId) || "";
  model.carrierScac = (userDetail?.memberDetailsResponse?.carrierInfo?.carrierScac) || "";
  model.carrierTier = (userDetail?.memberDetailsResponse?.carrierInfo?.carrierTier) || "";
  model.managedEquipmentCapability = (userDetail?.memberDetailsResponse?.carrierInfo?.managedEquipmentCapability) || null;
  model.nonManagedEquipmentCapability = (userDetail?.memberDetailsResponse?.carrierInfo?.nonManagedEquipmentCapability) || null;
  model.userRole = userRole.join(",");

  return model.getRequestPayload()
}
const getOriginCity =(originData:any)=>{
  return (originData?.city) || Anywhere;
  }
const getOriginState =(originData:any) => {
  return (originData?.state) || [];
  }
const getOriginCountry =(originData:any)=>{
  return (originData?.country) || "";
}
const getOriginPostalCode =(originData:any)=>{
  return (originData?.postalCode) || "";
  }
 

const constructSimilarRouterSearchData = (stopDetails: any, userDetail: any, offSet: any, transportMode: any) => {

  const pickUpStartDate = getDateTimeByTimezoneInISOStringFormat();
  const pickUpEndDate = getDateTimeByTimezoneInISOStringFormat(pickUpStartDate, offSet?.originDateDefaultOffset);
  const dropStartDate = getDateTimeByTimezoneInISOStringFormat();
  const dropEndDate = getDateTimeByTimezoneInISOStringFormat(dropStartDate, offSet?.destinationDateDefaultOffset);

  const originData = stopDetails?.find((stop: any) => (stop.stopType === "P"));
  const destinationData = stopDetails?.find((stop: any) => stop.stopType === "D");

  const userRole = getFormatRoles();
  const model: Search = new Search();
  model.originCity = getOriginCity(originData);
  model.originState = getOriginState(originData);
  model.originCountry = getOriginCountry(originData);
  model.originPostalCode = getOriginPostalCode(originData);
  model.originRadius = 100;
  model.pickUpStartDate = pickUpStartDate;
  model.pickUpEndDate = pickUpEndDate;
  model.destinationCity = getDestinationCity(destinationData);
  model.destinationStates = getDestinationStateArray(destinationData);
  model.destinationCountry = getDestinationCountry(destinationData);
  model.destinationPostalCode = getDestinationPostalCode(destinationData);
  model.dropStartDate = dropStartDate;
  model.dropEndDate = dropEndDate;
  model.destinationRadius = 100;
  model.trailerType = isValidTrailerType(transportMode);
  model.size = 25;
  model.page = 0;
  model.sortColumn = "pickUpStartDate";
  model.sortDirection = "asc";
  model.skipUserSearchHistory = true;
  model.userId = (userDetail?.memberDetailsResponse?.member?.upn) || "";
  model.carrierId = (userDetail?.memberDetailsResponse?.member?.carrierId) || "";
  model.carrierScac = (userDetail?.memberDetailsResponse?.carrierInfo?.carrierScac) || "";
  model.carrierTier = (userDetail?.memberDetailsResponse?.carrierInfo?.carrierTier) || "";
  model.managedEquipmentCapability =
  (userDetail?.memberDetailsResponse?.carrierInfo?.managedEquipmentCapability) || null;
  model.nonManagedEquipmentCapability =
  (userDetail?.memberDetailsResponse?.carrierInfo?.nonManagedEquipmentCapability) || null;
  model.userRole = userRole.join(",");

  return model.getRequestPayload()
}

const constructSimilarRouteSearchParams = (stopDetails: any, offSet: any, transportMode: any) => {

  const pickUpStartDate = getDateTimeByTimezoneInISOStringFormat();
  const pickUpEndDate = getDateTimeByTimezoneInISOStringFormat(pickUpStartDate, offSet?.originDateDefaultOffset);
  const dropStartDate = getDateTimeByTimezoneInISOStringFormat();
  const dropEndDate = getDateTimeByTimezoneInISOStringFormat(dropStartDate, offSet?.destinationDateDefaultOffset);
  const originData = stopDetails?.find((stop: any) => stop.stopType === "P");
  const destinationData = stopDetails?.find((stop: any) => stop.stopType === "D");
  const searchParams: Isearch = {
    origin: getOriginCity(originData),  // (originData && originData.city) || Anywhere,
    originCity: getOriginCity(originData),
    originState: getOriginState(originData),
    originCountry: getOriginCountry(originData),
    originPostalCode: getOriginPostalCode(originData),
    originRadius: 100,
    TrailerType: isValidTrailerType(transportMode),
    pickUpEndDate: pickUpEndDate,
    pickUpStartDate: pickUpStartDate,
    destination: (destinationData && (destinationData.city || destinationData.state)) ? `${destinationData.city}, ${destinationData.state}`  : Anywhere,
    destinationCity: getDestinationCity(destinationData),
    destinationStates: getDestinationStateArray(destinationData),
    destinationCountry: getDestinationCountry(destinationData),
    destinationRadius: 100,
    destinationPostalCode: getDestinationPostalCode(destinationData),
    dropStartDate: dropStartDate,
    dropEndDate: dropEndDate
  }
  return searchParams
}

const getEventDetails = (pathname:string,recommended:boolean) => {
 
  let analyticsDetails = {eventName:"",screenName:""};
  let eventName = EVENT.UE_MYLOADS_RELOAD;
  let screenName = SCREEN.MYLOADS;
  if (pathname.includes("/app/MyLoad")) {
    if (pathname.includes(CARRIER_ASSIGNED_MODULE_WEB)) {
      eventName = EVENT.UE_MYLOADS_RELOAD
      screenName = SCREEN.MYLOADS_CARRIER_ASSIGNED
    }
    if (pathname.includes("/app/MyLoad/DriverAssigned")) {
      eventName = EVENT.UE_MYLOADS_RELOAD
      screenName = SCREEN.MYLOADS_DRIVER_ASSIGNED
    }
    if (pathname.includes("/app/MyLoad/InTransit")) {
      eventName = EVENT.UE_MYLOADS_RELOAD
      screenName = SCREEN.MYLOADS_IN_TRANSIT
    }
    if (pathname.includes("/app/MyLoad/DeliveredNeedsPPWK")) {
      eventName = EVENT.UE_SIMILAR_MYLOADS
      screenName = SCREEN.MYLOADS_DELIVERED
    }
    if (pathname.includes("/app/MyLoad/DeliveredWithPPWK")) {
      eventName = EVENT.UE_SIMILAR_MYLOADS
      screenName = SCREEN.DELIVERED_WITH_PPWK
    }
    analyticsDetails = { eventName: eventName, screenName: screenName }
  }
  else if (pathname.includes("/app/home")) {
    analyticsDetails = { eventName: EVENT.UE_RECOMMENDED_RELOAD, screenName: SCREEN.RECOMMENDATION_HOME }
  }
  else if (pathname.includes("/app/search")) {
    analyticsDetails =  { eventName: getRecommededEvent(recommended), screenName: getSearchEventName(recommended) }
  }
  else if (manageCapacityPathCheck(pathname)) {
    analyticsDetails = { eventName: EVENT.UE_CAPACITY_RELOAD, screenName: SCREEN.MANAGE_CAPACITY }
  }
  return analyticsDetails;
} 

export { constructSearchData, constructSearchParams, constructSimilarRouterSearchData, constructSimilarRouteSearchParams, getEventDetails };

const manageCapacityPathCheck=(pathname: string) =>{
  return pathname.includes("/app/manage-capacity") && !isMobile;
}
const getSearchEventName=(recommended: boolean): string=> {
  return recommended ? SCREEN.RECOMMENDATION_SEARCH : SCREEN.SEARCH_RESULTS;
}

const getRecommededEvent=(recommended: boolean): string =>{
  return recommended ? EVENT.UE_RECOMMENDED_RELOAD : EVENT.UE_SEARCH_RELOAD;
}

